import { IUserInfo } from '@/common/dto/auth/UserInfo/Interface';
import { initPendo } from '@/common/utils/pendo';
import { BUILD_ENVIRONMENT_NAMES, USER_LOGOUT_URL, getFullAuthUrl } from '@/env-config';
import { baseApi } from '@/store/baseApi';

import { FSID_DOMAIN_PREFIX_MAP } from './constants';

let isFSIDPollerInitialized = false;
const initFSIDPoller = (sid: string) => {
  if (sid && !isFSIDPollerInitialized) {
    const FSID = (window as any).FormstackId as {
      SessionPoller: {
        setOptions: (options: {
          server: string;
          frequency: string;
          sid: string;
          onSessionExpired: () => void;
        }) => void;
        start: () => void;
      };
    };

    const env = process.env.COPILOT_BUILD_ENV;

    const domainPrefix = env && FSID_DOMAIN_PREFIX_MAP[env];

    if (FSID && domainPrefix) {
      FSID.SessionPoller.setOptions({
        server: `https://admin.${domainPrefix}formstack.com`,
        sid,
        frequency: '60',
        onSessionExpired: () => {
          window.location.assign(`${USER_LOGOUT_URL}?isPollerRequest=1`);
        },
      });

      FSID.SessionPoller.start();

      if (env === BUILD_ENVIRONMENT_NAMES.PRODUCTION) {
        // eslint-disable-next-line no-console
        console.log('>>> FSID Session Poller Started <<<');
      }

      isFSIDPollerInitialized = true;
    }
  }
};

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserInfo: build.query<IUserInfo, void>({
      query: () => getFullAuthUrl('/user-info'),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          const { data: user } = await queryFulfilled;

          if (user.sid) {
            initFSIDPoller(user.sid);
          }

          initPendo(user);
        } catch {
          return;
        }
      },
    }),
  }),
});

export const { useGetUserInfoQuery } = authApi;
